import VideoPreviewPlay from "./VideoPreviewPlay";
import VideoPreviewFullscreen from "./VideoPreviewFullscreen";
import VideoPreviewMute from "./VideoPreviewMute";
import { VideoPreviewSeekbar } from "./VideoPreviewSeekbar";
import VideoPreviewTime from "./VideoPreviewTime";
import { useSpaceToTogglePlay } from "../useSpaceToTogglePlay";

export const VIDEO_PREVIEW_CONTROLS_ID = "video-preview-controls";

export default function VideoPreviewControls({
  durationInFrames,
  fps,
}: {
  durationInFrames: number;
  fps: number;
}) {
  useSpaceToTogglePlay();

  return (
    <div className="absolute top-full right-0 left-0 pt-2">
      <div
        id={VIDEO_PREVIEW_CONTROLS_ID}
        className="z-0 flex h-12 w-full items-center gap-2 overflow-hidden rounded-lg bg-white px-3 shadow-card"
      >
        <VideoPreviewPlay />
        <VideoPreviewTime durationInFrames={durationInFrames} fps={fps} />
        <VideoPreviewSeekbar durationInFrames={durationInFrames} />
        <div>
          <VideoPreviewMute />
          <VideoPreviewFullscreen />
        </div>
      </div>
    </div>
  );
}
